import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

const LazyNav4RolloutAnalytics = lazyAfterPaint(() =>
	import(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-rollout-analytics" */ './index'
	).then(({ Nav4RolloutAnalytics }) => Nav4RolloutAnalytics),
);

const AsyncNav4RolloutAnalytics = () => (
	<JSErrorBoundary
		id="async-nav4-rollout-analytics"
		fallback="unmount"
		packageName="jiraNavigationAppsSidebarNav4RolloutAnalytics"
		teamName="jira-cosmos"
	>
		<Placeholder name="lazy-nav4-rollout-analytics">
			<LazyNav4RolloutAnalytics />
		</Placeholder>
	</JSErrorBoundary>
);

AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';

export default AsyncNav4RolloutAnalytics;
